import { render, staticRenderFns } from "./depositDeductDetail.vue?vue&type=template&id=2b6fa10e&scoped=true&"
import script from "./depositDeductDetail.vue?vue&type=script&lang=js&"
export * from "./depositDeductDetail.vue?vue&type=script&lang=js&"
import style0 from "./depositDeductDetail.vue?vue&type=style&index=0&id=2b6fa10e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6fa10e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b6fa10e')) {
      api.createRecord('2b6fa10e', component.options)
    } else {
      api.reload('2b6fa10e', component.options)
    }
    module.hot.accept("./depositDeductDetail.vue?vue&type=template&id=2b6fa10e&scoped=true&", function () {
      api.rerender('2b6fa10e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hotel/components/depositDeductDetail.vue"
export default component.exports